import * as t from '../types';

const INITIAL_STATE = {
  data: {},
  fetching: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case t.GET_REMOTE_CONFIG_REQUEST:
      return { ...state, fetching: true };

    case t.GET_REMOTE_CONFIG_SUCCESS:
      return { ...state, fetching: false, data: action.payload };

    case t.GET_REMOTE_CONFIG_FAILURE:
      return { ...state, fetching: false };

    case t.LOGOUT:
      return INITIAL_STATE;
    default:
      return { ...state };
  }
};
